export const transformBigIntToString = (bigInt: number): string => {
  return BigInt(bigInt).toString();
};
